import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../components/UI/Button';

const HeroSection: React.FC = () => {
  return (
    <div className="relative bg-gradient-to-r from-primary to-primary-dark min-h-[100vh] md:min-h-screen flex items-center pt-28 pb-16 md:pt-20 md:pb-0">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute right-0 top-0 w-1/2 h-full bg-accent-100 rounded-bl-full opacity-10"></div>
        <div className="absolute right-1/4 bottom-0 w-96 h-96 bg-accent rounded-full opacity-5"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center lg:text-left"
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white font-display mb-4 sm:mb-6 leading-tight">
              <span className="block">Adoptă un Câine!</span>
              <span className="block text-accent mt-1 sm:mt-2">Salvează o viață!</span>
            </h1>
            <p className="text-white/90 text-base sm:text-lg mb-6 sm:mb-8 max-w-lg mx-auto lg:mx-0">
                Centrul de adopții Odăi găzduiește aproximativ 550 de căței care așteaptă să meargă acasă. Toți câinii pleacă vaccinați, deparazitați și microcipați. Adopția e gratuită. Nu ne costă nimic să facem bine și de a da șansa unui cățel să ne devină prieten pe viață.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start">
              <Button href="/caini" variant="accent" size="lg" className="w-full sm:w-auto">
                Vezi câinii pentru adopție
              </Button>
              <Button href="https://docs.google.com/forms/d/e/1FAIpQLSd09cTbvA9b6a-lxOh-GbnSZ7s2O032iSqNKrDQximxuwXYOA/viewform" variant="white" size="lg" external={true} className="w-full sm:w-auto">
                Voluntariat
              </Button>
            </div>
          </motion.div>

          {/* Image - Hidden on small screens, smaller on medium+ */}
          <motion.div
            className="relative hidden md:block"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className="relative">
              {/* Purple circle background */}
              <div className="absolute -inset-3 bg-accent-100 rounded-full opacity-30"></div>
              
              {/* Little decoration circles */}
              <div className="absolute -top-6 right-6 w-6 h-6 bg-accent rounded-full opacity-40"></div>
              <div className="absolute top-16 -right-3 w-3 h-3 bg-accent rounded-full opacity-60"></div>
              
              {/* Dog image - smaller on medium screens */}
              <img
                src="/hero-dogs.jpg"
                alt="Dogs from Protecția Animalelor Sector 1"
                className="relative z-10 rounded-full w-full h-auto max-w-xs lg:max-w-md mx-auto object-cover aspect-square"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;